export default "__VITE_ASSET__fe24b3d8__"